import { render, staticRenderFns } from "./AgendaConfigureTimeslot.vue?vue&type=template&id=243a162e"
import script from "./AgendaConfigureTimeslot.vue?vue&type=script&lang=js"
export * from "./AgendaConfigureTimeslot.vue?vue&type=script&lang=js"
import style0 from "./AgendaConfigureTimeslot.vue?vue&type=style&index=0&id=243a162e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports